export default function ApplicationLogo(props) {
  const logo = "https://widget.entuitivecompliance.com/entuitive.svg";
  return <img {...props} src={logo} alt="Entuitive Compliance Logo" />;
}
